module.exports = require("@swa-ui/core/src/ButtonGroup/ButtonGroup.module.scss");